import React, {useState} from 'react'
import Stack from '@mui/material/Stack'
import {P415FileType} from '../client/P415Client'
import {Result} from '../client/Result'
import {CardSection} from './common/Card'
import {AutocompleteSelect, Select} from './common/MuiSelect'
import {UploadButton} from './common/UploadButton'

type FileTypeOption = { id: P415FileType; label: string }

type Props = {
    mpans: string[]
    onFileUpload: (mpan: string, fileType: P415FileType, file: File) => Promise<Result<null>>
    className?: string
}

const FILE_TYPE_OPTIONS: FileTypeOption[] = [
    { id: 'DeliveryData', label: 'Delivery Data' },
    { id: 'BaseCons', label: 'Baseline Consumption' },
    { id: 'OptCons', label: 'Optimised Consumption' },
]

export const P415FileUpload: React.FC<Props> = ({ mpans, onFileUpload, className }) => {
    const [mpan, setMpan] = useState<string>()
    const [fileType, setFileType] = useState<P415FileType>()

    return (
        <CardSection className={className} header="Upload P415 File to EDF" data-testid="p415-file-upload">
            <Stack spacing={2}>
                <AutocompleteSelect
                    label="MPAN"
                    data-testid="p415-mpan-select"
                    options={mpans.map(m => ({ id: m, label: m }))}
                    onChange={option => setMpan(option?.id)}
                />
                <Select
                    label="File Type"
                    data-testid="p415-file-type-select"
                    options={FILE_TYPE_OPTIONS}
                    onChange={option => setFileType(option?.id)}
                />
                <UploadButton
                    disabled={!mpan || !fileType}
                    onFileUpload={file => onFileUpload(mpan!, fileType!, file)}
                    successMessage="File uploaded successfully"
                />
            </Stack>
        </CardSection>
    )
}
